import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=f64513c0&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=js"
export * from "./DynamicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64513c0",
  null
  
)

export default component.exports